export default __webpack_public_path__ + "static/media/post-suvinil7.ba4b3201.png";